const URL_DYNATRACE_NON_PROD =
    'https://dynatrace.desjardins.com/jstag/managed/0a8b018a-cb27-43e7-b545-4ea4b71af8c7/acf20b4b382372da_complete.js';
const URL_DYNATRACE_PROD =
    'https://dynatrace.desjardins.com/jstag/managed/ee2574b1-c012-4f5f-b794-d380372fec7a/9b8794de14090474_complete.js';

export function addDynatraceTagScript(isNonProd: boolean): void {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.crossOrigin = 'anonymous';
    script.src = isNonProd ? URL_DYNATRACE_NON_PROD : URL_DYNATRACE_PROD;

    document.head.appendChild(script);
}
